import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import MainRouter from './router';
import LimitedAccessPage from 'pages/LimitedAccessPage'
import { UserContext } from './providers/userProvider';
import Loader from './components/loader/Loader';
import { getApiData, postData } from './lib/api/utils';
import { clearSession, endClosedBrowserSession, isClosedBrowserSession } from './lib/auth/session';
import { loadSignInSettings } from './new/signin/settings';
import { ACCESS_PATHS, askAccessState, rememberAccessState } from './new/signin/accessState';
import { SIGN_IN_PATHS } from './new/signin/constants';

function App() {
    const { setUser, user } = useContext(UserContext);
    const [loggedIn, setLoggedIn] = useState(false);
    const history = useHistory();

    useEffect(() => {
        authListener();
    }, []);

    const authListener = async () => {
        // The new sign-in's switch, read once for the page's life (off if it can't be read).
        // Unless a closed browser's session may have to end first, the signed-in person is
        // asked for at the same time, so the two calls don't wait on each other.
        const settings = loadSignInSettings();
        const me = isClosedBrowserSession() ? null : getApiData('Account/me');
        const { newSignIn } = await settings;
        if (newSignIn) {
            // "Keep me signed in" was off and the browser has been closed since: that session is over.
            endClosedBrowserSession();
        }

        const roles = await JSON.parse(localStorage.getItem('roles'));
        const response = await (me || getApiData('Account/me'));

        if (newSignIn && response?.item?.isRestrictedAccess && roles) {
            // New sign-in: a paused account gets the screen that says why, instead of the limited-access page.
            const access = await askAccessState(postData);
            rememberAccessState(access);
            clearSession();
            setUser(null);
            history.replace(ACCESS_PATHS[access?.state] || SIGN_IN_PATHS.PAUSED);
            setLoggedIn(true);
            return;
        }

        if (response?.item && roles) {
            setUser({
                ...response.item,
                isTemporaryPasswordChanged: user
                    ? user.isTemporaryPasswordChanged
                    : true,
                roles: localStorage.getItem('roles')
                    ? JSON.parse(localStorage.getItem('roles'))
                    : null,
            });
        } else {
            setUser(null);
        }
        setLoggedIn(true);
    };

    if (!loggedIn) {
        return <Loader />;
    }

    if (user?.isRestrictedAccess) {
        return <LimitedAccessPage />
    }

    return <MainRouter />;
}

export default App;
